import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const HALA_AVATAR = "/hala-96.png";

const COLORS = {
  primary: '#1B3A6B',
  gold: '#C5A572',
  white: '#FFFFFF',
  bg: '#F8FAFC',
  border: '#E2E8F0',
  text: '#1E293B',
  textMuted: '#64748B',
  error: '#EF4444',
  errorBg: '#FEF2F2',
};

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/control-center/auth/login`, { username, password });
      localStorage.setItem("hala_admin_token", res.data.token);
      localStorage.setItem("hala_admin_user", res.data.username);
      localStorage.setItem("hala_admin_role", res.data.role);
      navigate("/admin");
    } catch (err) {
      setError("بيانات الدخول غير صحيحة. يرجى المحاولة مرة أخرى.");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%',
    height: '44px',
    borderRadius: '12px',
    backgroundColor: COLORS.bg,
    border: `1px solid ${COLORS.border}`,
    padding: '0 14px',
    fontSize: '14px',
    outline: 'none',
    textAlign: 'right',
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(to bottom right, #F8FAFC, #EFF6FF)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '16px',
    }} dir="rtl">
      <div style={{ width: '100%', maxWidth: '380px' }}>
        {/* Logo Section */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '88px',
            height: '88px',
            borderRadius: '20px',
            border: `2px solid ${COLORS.gold}30`,
            backgroundColor: 'white',
            boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
            overflow: 'hidden',
            marginBottom: '16px',
          }}>
            <img src={HALA_AVATAR} alt="هلا" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
          <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: COLORS.primary, margin: 0 }}>لوحة إدارة هلا</h1>
          <p style={{ fontSize: '14px', color: COLORS.textMuted, marginTop: '4px' }}>مركز دلني للأعمال</p>
        </div>

        {/* Login Card */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '20px',
          boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
          border: `1px solid ${COLORS.border}`,
          padding: '28px',
        }}>
          <form onSubmit={handleLogin}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: 500, color: COLORS.text, marginBottom: '8px' }}>اسم المستخدم</label>
              <input
                data-testid="admin-username-input"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Admin"
                required
                style={inputStyle}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: 500, color: COLORS.text, marginBottom: '8px' }}>كلمة المرور</label>
              <input
                data-testid="admin-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                style={inputStyle}
              />
            </div>

            {error && (
              <div data-testid="admin-login-error" style={{
                fontSize: '14px',
                color: COLORS.error,
                backgroundColor: COLORS.errorBg,
                border: `1px solid ${COLORS.error}30`,
                borderRadius: '12px',
                padding: '12px 14px',
                marginBottom: '16px',
              }}>
                {error}
              </div>
            )}

            <button
              data-testid="admin-login-btn"
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                height: '48px',
                borderRadius: '12px',
                backgroundColor: COLORS.primary,
                color: 'white',
                fontSize: '16px',
                fontWeight: 600,
                border: 'none',
                cursor: loading ? 'default' : 'pointer',
                opacity: loading ? 0.6 : 1,
                marginTop: '8px',
              }}
            >
              {loading ? "جاري الدخول..." : "دخول"}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', fontSize: '12px', color: COLORS.textMuted, marginTop: '24px' }}>
          هلا &copy; 2024
        </p>
      </div>
    </div>
  );
}
